import { entitlementsSelectors } from 'app-components/flux/entitlements';
import { getNavFromKey, navOrderV2 } from 'containers/App/paths';
import { useAppSelector } from 'hooks/redux';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { GroupNavItem, MainNavItem } from '../NavItems';

const useStyles = makeStyles()(() => ({
  navPopover: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

type NavPopoverProps = {
  closeDrawer: () => void;
};

export const NavPopoverV2 = React.memo(function NavPopoverV0({ closeDrawer }: NavPopoverProps) {
  const { classes } = useStyles();
  const tierId: string = useAppSelector((state) => entitlementsSelectors.getTopTierEntitlement(state)?.id);
  const businessEnabled = useAppSelector(entitlementsSelectors.getBusinessEnabled);

  return (
    <div className={classes.navPopover}>
      {navOrderV2.map((navKey) => {
        // Group Header
        if (Array.isArray(navKey)) {
          if (navKey[0] === 'Business' && !businessEnabled) {
            return null;
          }
          return <GroupNavItem key={`group-${navKey[0]}`} />;
        }

        // Nav Item
        const nav = getNavFromKey(navKey);
        if (nav && (!nav.hideOnTiers.length || !nav.hideOnTiers.includes(tierId))) {
          return <MainNavItem key={`nav-item-${nav.path}`} nav={nav} displayNode='all' closeHeader={closeDrawer} />;
        }
        return null;
      })}
    </div>
  );
});
